export enum PaymentMethodExpiresTypes {
	ShowPaymentMethodExpiresSoonBanner = 'showPaymentMethodExpiresSoonBanner',
	ShowPaymentMethodExpiresBeforePaymentBanner = 'showPaymentMethodExpiresBeforePaymentBanner',
	ShowPaymentMethodExpiredBanner = 'showPaymentMethodExpiredBanner',
}

export type PaymentMethodExpiresBannerProps = {
	type: `${PaymentMethodExpiresTypes}`;
};
